
import { CommonModule, DatePipe } from "@angular/common";
import { finalize } from "rxjs";
import { Component, OnInit, signal } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { RouterLink, RouterLinkActive } from "@angular/router";
import {
  TuiDataList,
  TuiDropdown,
  TuiSizeL,
  TuiSizeS,
  TuiTextfield,
} from "@taiga-ui/core";
import {
  TuiDataListDropdownManager,
  TuiDataListWrapper,
  TuiTabs,
} from "@taiga-ui/kit";
import {
  TuiNavigation,
} from "@taiga-ui/layout";
import { AdminService } from "../../core/services/admin.service";
import { TuiTable } from "@taiga-ui/addon-table";
import { AuthService } from "../../core/services/auth.service";
import { TuiDropdownAlign } from '@taiga-ui/core';

const ICON =
  "data:image/svg+xml,%0A%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='32' height='32' rx='8' fill='url(%23paint0_linear_2036_35276)'/%3E%3Cmask id='mask0_2036_35276' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='6' y='5' width='20' height='21'%3E%3Cpath d='M18.2399 9.36607C21.1347 10.1198 24.1992 9.8808 26 7.4922C26 7.4922 21.5645 5 16.4267 5C11.2888 5 5.36726 8.69838 6.05472 16.6053C6.38707 20.4279 6.65839 23.7948 6.65839 23.7948C8.53323 22.1406 9.03427 19.4433 8.97983 16.9435C8.93228 14.7598 9.55448 12.1668 12.1847 10.4112C14.376 8.94865 16.4651 8.90397 18.2399 9.36607Z' fill='url(%23paint1_linear_2036_35276)'/%3E%3Cpath d='M11.3171 20.2647C9.8683 17.1579 10.7756 11.0789 16.4267 11.0789C20.4829 11.0789 23.1891 12.8651 22.9447 18.9072C22.9177 19.575 22.9904 20.2455 23.2203 20.873C23.7584 22.3414 24.7159 24.8946 24.7159 24.8946C23.6673 24.5452 22.8325 23.7408 22.4445 22.7058L21.4002 19.921L21.2662 19.3848C21.0202 18.4008 20.136 17.7104 19.1217 17.7104H17.5319L17.6659 18.2466C17.9119 19.2306 18.7961 19.921 19.8104 19.921L22.0258 26H10.4754C10.7774 24.7006 12.0788 23.2368 11.3171 20.2647Z' fill='url(%23paint2_linear_2036_35276)'/%3E%3C/mask%3E%3Cg mask='url(%23mask0_2036_35276)'%3E%3Crect x='4' y='4' width='24' height='24' fill='white'/%3E%3C/g%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear_2036_35276' x1='0' y1='0' x2='32' y2='32' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23A681D4'/%3E%3Cstop offset='1' stop-color='%237D31D4'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint1_linear_2036_35276' x1='6.0545' y1='24.3421' x2='28.8119' y2='3.82775' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0.0001' stop-opacity='0.996458'/%3E%3Cstop offset='0.317708'/%3E%3Cstop offset='1' stop-opacity='0.32'/%3E%3C/linearGradient%3E%3ClinearGradient id='paint2_linear_2036_35276' x1='6.0545' y1='24.3421' x2='28.8119' y2='3.82775' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0.0001' stop-opacity='0.996458'/%3E%3Cstop offset='0.317708'/%3E%3Cstop offset='1' stop-opacity='0.32'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A";


@Component({
  standalone: true,
  selector: 'app-secondary-layout',
  imports: [
    FormsModule,
    TuiDataList,
    TuiDropdown,
    TuiNavigation,
    TuiTabs,
    TuiTextfield,
    RouterOutlet,
    CommonModule,
    TuiDataListWrapper,
    TuiTable,
    TuiDataListDropdownManager,
    ReactiveFormsModule
  ],
  templateUrl: './secondary-layout.component.html',
  styleUrl: './secondary-layout.component.scss'
})
export class SecondaryLayoutComponent implements OnInit {

  protected expanded = signal(true);
    protected open = false;
    align: TuiDropdownAlign = 'center'; 
    protected switch = false;
    loggedInUserName: string | null = null;
    loggedInUserRole: string | "Role" = "Role";
    loggedInUserID: string | null = null;
    loggedInUserImage: string | null = null;
    protected readonly routes: any = {};
    protected readonly breadcrumbs = [
      "Home",
      "Angular",
      "Repositories",
      "Taiga UI",
    ];
  
    constructor(
        private authService: AuthService,
        private router: Router,
        private route: ActivatedRoute,
        private adminService: AdminService
      ) {

    }
  
    ngOnInit(): void {
      this.loadLoggedInUser();
      this.ensureDefaultChildRouteOrRedirect();
    }

    /**
     * `/nurse` and `/client` have no child route at the parent path — the outlet is empty.
     * Redirect to the correct home for the logged-in role (e.g. super admin was wrongly sent to `/nurse`).
     */
    private ensureDefaultChildRouteOrRedirect(): void {
      const path = (
        this.router.url.split(/[?#]/)[0] || ""
      ).replace(/\/+$/, "");
      if (path !== "/nurse" && path !== "/client") return;

      const user = this.authService.getLoggedInUser();
      const home = this.authService.getHomeUrlForCurrentUser();

      if (path === "/nurse") {
        if (!user || !home) {
          this.router.navigateByUrl("/welcome", { replaceUrl: true });
          return;
        }
        if (user.type !== "NURSE") {
          this.router.navigateByUrl(home, { replaceUrl: true });
          return;
        }
        this.router.navigateByUrl(`/nurse/nurse-profile/${user._id}`, {
          replaceUrl: true,
        });
        return;
      }

      if (path === "/client") {
        if (!user || !home) {
          this.router.navigateByUrl("/welcome", { replaceUrl: true });
          return;
        }
        if (user.type !== "CLIENT") {
          this.router.navigateByUrl(home, { replaceUrl: true });
          return;
        }
        this.router.navigateByUrl(`/client/client-profile/${user._id}`, {
          replaceUrl: true,
        });
      }
    }
  
    loadLoggedInUser(): void {
      const user = this.authService.getLoggedInUser();
      if (!user) {
        this.authService.clearClientAuthStateWithoutServerCall();
        void this.router.navigateByUrl("/welcome");
        return;
      }
      this.loggedInUserName = user.userName ?? null;
      this.loggedInUserImage = user.profilePic ?? null;
      this.loggedInUserRole = user.type ?? "Role";
      this.loggedInUserID = user._id ?? null;
    }
  
    logout(): void {
      this.authService
        .logout()
        .pipe(
          finalize(() => {
            this.authService.clearClientAuthStateWithoutServerCall();
            void this.router.navigateByUrl("/welcome");
          }),
        )
        .subscribe({ error: () => {} });
    }
  
    viewMyAccount(data: any): void {
      this.router.navigate([`nurse/nurse-profile/${data}`]);
    }
  
    protected readonly drawer = {
      Components: [
        { name: "Button", icon: ICON },
        { name: "Input", icon: ICON },
        { name: "Tooltip", icon: ICON },
      ],
      Essentials: [
        { name: "Getting started", icon: ICON },
        { name: "Showcase", icon: ICON },
        { name: "Typography", icon: ICON },
      ],
    };
  
    protected handleToggle(): void {
      this.expanded.update((e) => !e);
    }
  
  
    //Dropdown
  
    navigateTo(index: number): void {
        switch(index) {
          case 0:
            this.router.navigate(['/admin/users']);
            break;
          case 1:
            this.router.navigate(['/admin/users']);
            break;
        }
      }
    
  
      protected size: TuiSizeL | TuiSizeS = "s";
      protected openDropdown = false;

}
